import axios from '@/components/api/axios';

async function getInvoiceNumber() {
  const res = await axios.axiosGet('/api/invoiceNumber/get', null);
  return res;
}

async function updateInvoiceNumber(invoiceNumber) {
  let data = {
    invoiceNumber: invoiceNumber
  }
  const res = await axios.axiosPost('/api/invoiceNumber/update', data);
  return res;
}

export default {
  getInvoiceNumber,
  updateInvoiceNumber
}



// WEBPACK FOOTER //
// ./src/components/api/invoice/invoice.js